<template>
  <v-dialog v-model="dialogshowimage_profile" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card style="background-color: rgba(0, 0, 0, 0.9);">
      <v-toolbar dark style="background: none !important;">
        <v-flex xl12 lg12 md12 sm12 style="text-align: right;    background: none !important;">
          <v-btn icon @click="closeDialogShowImage_Profile">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-flex>
      </v-toolbar>
      <div style="background: none;">
        <img class="modal-contentc" :src="pathpicture" v-if="pathpicture">
        <img class="modal-contentc" src="/static/img/default_profile/group-white.png" v-else-if="typepathpicture=='group'">
        <img class="modal-contentc" src='/static/img/default_profile/business-white.png' v-else-if="typepathpicture=='business'">
        <img class="modal-contentc" src='/static/img/default_profile/bot-white.png' v-else-if="typepathpicture=='bot'">
        <img class="modal-contentc" src='/static/img/default_profile/man-white.png' v-else>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify'
import {Momenttime, Decode} from '@/services'

export default {
  props: {dialogshowimage_profile: false, pathpicture: '', typepathpicture: ''},
  data: () => ({
    token: ''
  }),
  computed: {
    ...sync('*')
  },
  watch: {

  },

  // item.message, item.file_name, item.nickname, item.path_pic, dateMoment(item.timestamp),timeMoment(item.timestamp), item.tokenmessage, item.type)
  methods: {
    loadpic(filenameSend) {
      this.axios.get(this.DetailImage.path, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    sendimgonebox (tokenmessage) {
      this.axios.post(process.env.APIpub + '/save_onebox2', {
        tokenmessage: tokenmessage,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          this.$swal(
            'Send Success!',
            'Your file has been sent.',
            'success'
          )
        }
      })
    },
    closeDialogShowImage_Profile () {
      this.$emit('closeDialogShowImage_Profile', false)
    },
    date (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    }
    // this.dateSend = Momenttime.momentdatethai(timestamp)
    //   // this.timeSend = Momenttime.momenttimethai(timestamp)
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  }
}
</script>
<style scoped>
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 80vh;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
}
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/ShowImage_ProfileDialog.vue